import { Flame, Beef, Droplets, Wheat, Info } from 'lucide-react';
import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const macros = [
  { key:'protein', label:'Белки',   unit:'г', icon:Beef,     color:'#00CFDB' },
  { key:'fat',     label:'Жиры',    unit:'г', icon:Droplets, color:'#9B6FD4' },
  { key:'carbs',   label:'Углев.',  unit:'г', icon:Wheat,    color:'#F59E0B' },
];

export default function KbjuCard({ kbju }) {
  const { isDark, theme } = useTheme();
  const [showInfo, setShowInfo] = useState(false);
  if (!kbju) return null;

  const acc  = theme.accent;
  const card = isDark ? '#1A1526' : '#FFFFFF';
  const bdr  = isDark ? 'rgba(255,255,255,.07)' : 'rgba(0,0,0,.06)';
  const txt  = isDark ? '#F2EEF9' : '#2D1B35';
  const mut  = isDark ? 'rgba(200,185,220,.55)' : 'rgba(80,60,100,.5)';
  const sub  = isDark ? 'rgba(255,255,255,.05)' : 'rgba(0,0,0,.04)';

  return (
    <div style={{ background:card, border:`1px solid ${bdr}`, borderRadius:16, padding:'1rem',
                  boxShadow:isDark?'0 2px 12px rgba(0,0,0,.3)':'0 2px 16px rgba(100,60,140,.08)' }}>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
        <p style={{ color:mut, fontSize:'.68rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.08em', margin:0 }}>
          Суточный рацион (КБЖУ)
        </p>
        <button onClick={() => setShowInfo(s=>!s)} style={{ background:'none', border:'none', cursor:'pointer', color:mut, padding:2 }}>
          <Info size={14}/>
        </button>
      </div>

      {showInfo && (
        <div style={{ background:sub, borderRadius:10, padding:'10px 12px', marginBottom:12, fontSize:'.78rem', color:mut, lineHeight:1.6 }}>
          <p style={{ margin:'0 0 4px', fontWeight:600, color:txt }}>Как считается?</p>
          <p style={{ margin:'0 0 3px' }}>Формула Миффлина-Сан Жеора с учётом пола, возраста, роста и веса.</p>
          <p style={{ margin:'0 0 3px' }}>Для похудения: −400 ккал от нормы. Для набора: +300 ккал.</p>
          <p style={{ margin:0, color:acc }}>Цифры приблизительные — точнее покажет практика.</p>
        </div>
      )}

      {/* Калории */}
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
        <div style={{ width:42, height:42, borderRadius:12, background:`${acc}18`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <Flame size={20} style={{ color:acc }}/>
        </div>
        <div>
          <div style={{ display:'flex', alignItems:'baseline', gap:4 }}>
            <span style={{ color:acc, fontFamily:'Nunito,system-ui', fontSize:'2rem', fontWeight:800, lineHeight:1 }}>
              {kbju.calories}
            </span>
            <span style={{ color:mut, fontSize:'.8rem' }}>ккал / день</span>
          </div>
          <p style={{ color:mut, fontSize:'.72rem', margin:'2px 0 0' }}>
            Цель с учётом активности
          </p>
        </div>
      </div>

      {/* БЖУ */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8, marginBottom:12 }}>
        {macros.map(({ key, label, unit, icon:Icon, color }) => (
          <div key={key} style={{ background:sub, borderRadius:12, padding:'10px 12px' }}>
            <Icon size={13} style={{ color, marginBottom:5 }}/>
            <p style={{ color:txt, fontFamily:'Nunito,system-ui', fontWeight:700, fontSize:'1.1rem', margin:'0 0 2px', lineHeight:1 }}>
              {kbju[key]}<span style={{ color:mut, fontSize:'.72rem', fontWeight:400, marginLeft:2 }}>{unit}</span>
            </p>
            <p style={{ color:mut, fontSize:'.68rem', margin:0 }}>{label}</p>
          </div>
        ))}
      </div>

      {/* BMR / TDEE — с объяснением */}
      <div style={{ borderTop:`1px solid ${bdr}`, paddingTop:10, display:'flex', gap:0, flexDirection:'column', gap:4 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:mut, fontSize:'.75rem' }}>
            🛌 Базовый обмен (в полном покое)
          </span>
          <span style={{ color:txt, fontSize:'.8rem', fontWeight:600 }}>{kbju.bmr} ккал</span>
        </div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:mut, fontSize:'.75rem' }}>
            🏃 Суточный расход (с активностью)
          </span>
          <span style={{ color:txt, fontSize:'.8rem', fontWeight:600 }}>{kbju.tdee} ккал</span>
        </div>
      </div>
    </div>
  );
}
